import { useState, useEffect } from "react";
import { weatherApi } from "../api/weatherApi";

export const useWeather = (lat, lon) => {
  const [weather, setWeather] = useState(null);
  const [forecast, setForecast] = useState(null);
  const [windyData, setWindyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const currentWeather = await weatherApi.getCurrentWeather(lat, lon);
        const weeklyForecast = await weatherApi.getForecast(lat, lon);
        const windyForecast = await weatherApi.getWindyForecast(lat, lon);

        setWeather(currentWeather);
        setForecast(weeklyForecast);
        setWindyData(windyForecast);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchWeather();
  }, [lat, lon]);

  return { weather, forecast, windyData, loading, error };
};